import SelectionDesignItem from './selection/design_item_base';

export default class extends SelectionDesignItem {
  static targets = ['label'];
  static values = {
    labelOn: String,
    labelOff: String,
  };

  _renderLabels() {
    this.labelTarget.textContent = this.checkedFor('shared')
      ? this.labelOnValue
      : this.labelOffValue;
  }
}
